export const entityName = 'dataStoreRequestActions';
export const idAttribute = 'requestActionId';
